import { ArgsType } from '@nestjs/graphql'
import { BaseAddPictureDto } from '../base/baseAddPicture.dto'

@ArgsType()
export class UserAddPictureDto extends BaseAddPictureDto { }
